"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startsWith = exports.endsWith = void 0;
/**
 * Return a case transformation function that ensures a string ends with another string
 *
 * @param endOfWord - The expected endsWith of the word
 * @param convertWord - A case conversion to apply to word before checking
 * @returns The case conversion function
 */
function endsWith(endOfWord, convertWord = (x) => x) {
    return (word) => {
        const convertedWord = convertWord(word);
        return convertedWord.endsWith(endOfWord)
            ? convertedWord
            : `${convertedWord}${endOfWord}`;
    };
}
exports.endsWith = endsWith;
/**
 * Return a case transformation function that ensures a string starts with another string
 *
 * @param startOfWord - The expected startsWith of the word
 * @param convertWord - A case conversion to apply to word before checking
 * @returns The case conversion function
 */
function startsWith(startOfWord, convertWord = (x) => x) {
    return (word) => {
        const convertedWord = convertWord(word);
        return convertedWord.startsWith(startOfWord)
            ? convertedWord
            : `${startOfWord}${convertedWord}`;
    };
}
exports.startsWith = startsWith;
//# sourceMappingURL=conditionalAdd.js.map